<template lang="pug">
    #splash
        Logo
</template>

<script>
import Logo from "@/components/Logo";
export default {
  name: "SplashScreen",
  components: {
    Logo
  }
};
</script>

<style lang="scss" scoped>
#splash {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;

  .logo {
    width: auto;
    height: 10rem;
    flex: 1;
    animation: blink infinite 1s;
  }

  &.fade-enter,
  &.fade-leave-to {
    .logo {
      animation-play-state: paused;
    }
  }
}
</style>
